module.exports = __webpack_public_path__ + "static/media/shoe-prints.75fa6f0d.svg";